import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'trunk',
      d: 'M-1.5,-2h0.5v0.5h-0.5zM0,-2h1v4h-1zM-1,-1.5h0.5v3.5h-0.5zM-1,2h2.5v0.5h-2.5zM-1,2.5h3v0.5h-3z',
    },
    {
      paint: [
        ['haybale', 0.36],
        ['trunk', 0.64],
      ],
      d: 'M-1,-2h1v0.5h-1zM1,-2h0.5v0.5h-0.5zM-0.5,-1.5h0.5v3.5h-0.5z',
    },
    {
      paint: 'oakGold',
      d: 'M-1,-7h1.5v0.5h-1.5zM-2.5,-6.5h1.5v0.5h-1.5zM0,-6.5h2.5v0.5h-2.5zM-3,-6h1v1h-1zM1.5,-6h1v0.5h-1zM2,-5.5h1v0.5h-1zM-3.5,-5h1v0.5h-1zM2.5,-5h1v0.5h-1zM-3.5,-4.5h4v1h-4zM3,-4.5h0.5v2h-0.5zM-3.5,-3.5h3.5v0.5h-3.5zM-3,-3h2.5v0.5h-2.5zM-3,-2.5h2v0.5h-2zM0,-2.5h0.5v0.5h-0.5zM2,-2.5h0.5v0.5h-0.5zM1.5,-2h0.5v0.5h-0.5z',
    },
    {
      paint: 'oakBrown',
      d: 'M1.5,-5.5h0.5v0.5h-0.5zM0.5,-5h2v0.5h-2zM0.5,-4.5h2.5v1h-2.5zM0,-3.5h3v0.5h-3zM-0.5,-3h3.5v0.5h-3.5zM-1,-2.5h1v0.5h-1zM0.5,-2.5h1.5v0.5h-1.5z',
    },
    { paint: 'autumnGold', d: 'M-1,-6.5h1v0.5h-1zM-2,-6h3.5v1h-3.5zM-2.5,-5h3v0.5h-3z' },
  ],
  pixels: 162,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'trunk',
      d: 'M-2,-2.5h0.5v0.5h-0.5zM-1.5,-2h0.5v0.5h-0.5zM-0.5,-2h2v0.5h-2zM-1,-1.5h0.5v3.5h-0.5zM0,-1.5h1v3.5h-1zM-1,2h2.5v0.5h-2.5zM-1,2.5h3v0.5h-3z',
    },
    {
      paint: [
        ['haybale', 0.36],
        ['trunk', 0.64],
      ],
      d: 'M-1.5,-2.5h0.5v0.5h-0.5zM0,-2.5h0.5v0.5h-0.5zM-1,-2h0.5v0.5h-0.5zM-0.5,-1.5h0.5v3.5h-0.5z',
    },
    {
      paint: 'autumnBronze',
      d: 'M-2,-7h2.5v0.5h-2.5zM-2.5,-6.5h1.5v0.5h-1.5zM0,-6.5h2v0.5h-2zM-2.5,-6h0.5v0.5h-0.5zM1.5,-6h1v1h-1zM-3,-5.5h1v0.5h-1zM-3.5,-5h1v0.5h-1zM2.5,-5h1v0.5h-1zM-3.5,-4.5h4v1h-4zM3,-4.5h0.5v2h-0.5zM-3.5,-3.5h3.5v0.5h-3.5zM-3,-3h2.5v0.5h-2.5zM-2.5,-2.5h0.5v0.5h-0.5zM0.5,-2.5h0.5v0.5h-0.5zM2,-2.5h1v0.5h-1z',
    },
    {
      paint: 'oakBrown',
      d: 'M0.5,-5h2v0.5h-2zM0.5,-4.5h2.5v1h-2.5zM0,-3.5h3v0.5h-3zM-0.5,-3h3.5v0.5h-3.5zM-1,-2.5h1v0.5h-1zM1,-2.5h1v0.5h-1z',
    },
    { paint: 'autumnOlive', d: 'M-1,-6.5h1v0.5h-1zM-2,-6h3.5v1h-3.5zM-2.5,-5h3v0.5h-3z' },
  ],
  pixels: 160,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'trunk',
      d: 'M-1.5,-2h0.5v0.5h-0.5zM-0.5,-2h2v0.5h-2zM-1,-1.5h0.5v3.5h-0.5zM0,-1.5h1v3.5h-1zM-1,2h2.5v0.5h-2.5zM-1,2.5h3v0.5h-3z',
    },
    {
      paint: [
        ['haybale', 0.36],
        ['trunk', 0.64],
      ],
      d: 'M1.5,-5.5h0.5v0.5h-0.5zM0.5,-5h0.5v0.5h-0.5zM-1,-3h0.5v1.5h-0.5zM1,-2.5h1v0.5h-1zM-0.5,-1.5h0.5v3.5h-0.5z',
    },
    {
      paint: 'autumnRust',
      d: 'M-1,-7h1.5v0.5h-1.5zM-2,-6.5h1v0.5h-1zM0,-6.5h2.5v0.5h-2.5zM-2.5,-6h0.5v0.5h-0.5zM1.5,-6h1v0.5h-1zM-3,-5.5h1v0.5h-1zM2,-5.5h1v0.5h-1zM2.5,-5h1v0.5h-1zM-3.5,-4.5h4v1h-4zM3,-4.5h0.5v2h-0.5zM-3.5,-3.5h3.5v0.5h-3.5zM-3.5,-3h2.5v0.5h-2.5zM-3,-2.5h2v0.5h-2zM0.5,-2.5h0.5v0.5h-0.5zM2,-2.5h1v0.5h-1zM1.5,-2h0.5v0.5h-0.5z',
    },
    {
      paint: 'autumnBurgundy',
      d: 'M1,-5h1.5v0.5h-1.5zM0.5,-4.5h2.5v1.5h-2.5zM0,-3h2.5v0.5h-2.5zM-1.5,1.5h0.5v0.5h-0.5z',
    },
    { paint: 'autumnBronze', d: 'M-1,-6.5h1v0.5h-1zM-2,-6h3.5v1h-3.5zM-3,-5h3.5v0.5h-3.5z' },
    {
      paint: [
        ['autumnBurgundy', 0.7],
        ['trunk', 0.3],
      ],
      d: 'M0,-3.5h0.5v0.5h-0.5zM-0.5,-3h0.5v0.5h-0.5zM2.5,-3h0.5v0.5h-0.5zM-0.5,-2.5h1v0.5h-1zM-2.5,2h1.5v0.5h-1.5zM-2,2.5h1v0.5h-1z',
    },
  ],
  pixels: 167,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
